<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <sarala-table :model="model" ref="table">
                    <template #top-left>
                        <v-row class="px-5 py-3">
                            <v-col>
                                <span class="overline">{{
                                    $t(
                                        'commissions.configurations.breadcrumbs.index',
                                    )
                                }}</span>
                            </v-col>
                        </v-row>
                    </template>

                    <template #commission_cycle="{ item }">
                        <span>{{
                            getCommissionCycleLabel(item.commission_cycle)
                        }}</span>
                    </template>
                    <template #fixed_category_payment_limit="{ item }">
                        <span>{{
                            item.fixed_category_payment_limit || '-'
                        }}</span>
                    </template>

                    <template #action="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    icon
                                    tile
                                    v-on="on"
                                    :to="{
                                        name: $t(
                                            'commissions.configurations.routes.edit',
                                        ),
                                        params: {
                                            id: item.id,
                                        },
                                    }"
                                >
                                    <v-icon color="blue-grey" v-on="on"
                                        >mdi-pencil</v-icon
                                    >
                                </v-btn>
                            </template>
                            <span>{{ $t('form.actions.edit') }}</span>
                        </v-tooltip>
                    </template>
                </sarala-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import SaralaTable from '@/shared/components/SaralaTable'
import Configuration from '@/models/commission/Configuration'
import CommissionCycle from '@/enums/CommissionCycle'

export default {
    components: {
        SaralaTable,
    },

    methods: {
        getCommissionCycleLabel(value) {
            return CommissionCycle.getLabel(value) || '-'
        },
    },

    computed: {
        model() {
            return new Configuration()
        },
    },
}
</script>
